import { Component, Input, AfterViewInit, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'app-bar-graph',
  templateUrl: './bar-graph.component.html',
  styleUrls: ['./bar-graph.component.scss']
})
export class BarGraphComponent implements AfterViewInit {

  @Input() title: string = '';
  @Input() state: string = '';
  @Input() data: { name: string, value: number }[] = [];

  @ViewChild('canvas', { static: true }) canvas!: ElementRef<HTMLCanvasElement>;

  barHeight = 22;
  barGap = 10;
  leftLabelWidth = 230;

  // 🎨 Color scheme you provided
  colorScheme = [
    "#4E79A7", "#F28E2B", "#E15759", "#76B7B2",
    "#59A14F", "#EDC949", "#AF7AA1", "#FF9DA7",
    "#9C755F", "#BAB0AB", "#2A9D8F", "#E76F51"
  ];

  ngAfterViewInit(): void {
    this.draw();
  }

  redraw(){
    this.draw();
  }

  draw() {
    const canvas = this.canvas.nativeElement;
    const ctx = canvas.getContext('2d')!;
    const maxValue = Math.max(...this.data.map(d => d.value));

    // Adjust canvas height dynamically
    canvas.height = this.data.length * (this.barHeight + this.barGap);

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.font = "13px Arial";

    this.data.forEach((item, index) => {
      const y = index * (this.barHeight + this.barGap);

      // ---- LABEL ----
      ctx.fillStyle = "#333";
      ctx.textBaseline = "top";
      ctx.fillText(item.name, 0, y);

      // ---- BAR WIDTH ----
      const chartWidth = canvas.width - this.leftLabelWidth - 40;
      const barWidth = (item.value / maxValue) * chartWidth;

      // ---- BAR COLOR (cycled from the list) ----
      const barColor = this.colorScheme[index % this.colorScheme.length];

      // ---- DRAW BAR ----
      ctx.fillStyle = barColor;
      ctx.fillRect(this.leftLabelWidth, y + 5, barWidth, this.barHeight);

      // ---- VALUE AT END OF BAR ----
      ctx.fillStyle = "#000";
      ctx.fillText(item.value.toString(), this.leftLabelWidth + barWidth + 8, y);
    });
  }
}
